import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../Features/orderDetailsSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';

function ImageModal() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const modalImage = useSelector((state) => state.orderDetails.modalImage);

    return (
        <div className='h-[80%] w-[40%] text-center flex items-center justify-center'>
            <img ref={wrapperRef} className='max-h-full max-w-full' src={modalImage} alt="" />
        </div>
    );
}

export default ImageModal;
